import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Clock, Brain, FlaskConical, Users, FileQuestion, Image } from 'lucide-react';
const problems = [{
  icon: FileQuestion,
  text: 'Buscar o armar guías que no sean aburridas'
}, {
  icon: Brain,
  text: 'Traducir contenidos complejos a lenguaje simple'
}, {
  icon: FlaskConical,
  text: 'Inventar experimentos posibles (con lo que hay)'
}, {
  icon: Users,
  text: 'Mantener atención en grupos con poca motivación'
}, {
  icon: Clock,
  text: 'Evaluar más que “memoria”, sin hacer un examen imposible'
}, {
  icon: Image,
  text: 'Preparar material visual porque si no… no se entiende'
}];
export const ProblemSection: React.FC = () => {
  return <section className="py-16 bg-white" data-id="element-111">
      <div className="container mx-auto px-4" data-id="element-112">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-114">
            Si enseñás Ciencias, seguro te pasa esto:
          </h2>
          <p className="text-lg text-gray-600" data-id="element-115">
            Ciencias no es solo “explicar un tema”. Ciencias exige claridad,
            evidencia y actividades que funcionen. Y eso implica:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-116">
          {problems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-stone-50 p-6 rounded-xl border border-stone-100 hover:border-amber-200 hover:shadow-md transition-all duration-300" data-id="element-117">
              <div className="bg-amber-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4 text-amber-600" data-id="element-118">
                <item.icon className="w-6 h-6" data-id="element-119" />
              </div>
              <p className="text-gray-800 font-medium" data-id="element-120">{item.text}</p>
            </motion.div>)}
        </div>

        <div className="mt-12 max-w-2xl mx-auto text-center bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-121">
          <p className="text-xl font-semibold text-red-800 mb-2" data-id="element-122">
            Y al final pasa lo típico:
          </p>
          <p className="text-gray-700 italic" data-id="element-123">
            "Planificás un montón… pero igual sentís que siempre falta algo.
            Porque sin recursos listos, Ciencias te come tiempo."
          </p>
        </div>
      </div>
    </section>;
};